/**
 * @file Utility functions for locale management
 */

import dayjs from 'dayjs';

import { Locale } from '../generated/graphql';

/**
 * Get the locale for a given language code.
 * (Used for dayjs localization)
 *
 * @param language The language code to get the locale for
 * @returns        The locale string for the given language code, or 'en-gb' if null or 'en'
 */
export const getDayJsLocaleForLanguage = (language: Locale | null): string => {
  // We want to use DD/MM/YYYY as the default date format and 'en-gb' is the 'en' locale that uses this format.
  if (language === null || language === 'en') {
    return 'en-gb'; // Default locale
  }

  return dayjs.locale(language);
};
